import { useAppContext } from "../../../state/app/context";

const Authorize = ({ gameAccess, children }) => {
	const { state } = useAppContext();
	const currentGameAccess = state.gameAccess();

	return currentGameAccess.some((ga) => gameAccess.includes(ga)) ||
		gameAccess.includes("ALL")
		? children
		: null;
};

export default Authorize;
